import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { AbTestsForTable, AbTestsSortBy } from '../types'
import { AbTestsForTableDTO, AbTestsSortByDTO } from './types'

export const fromDTO = (from: AbTestsForTableDTO) =>
  mapDTO<AbTestsForTableDTO, AbTestsForTable>({ from }).transform(
    ({ domain, endedAt, startedAt, status, updatedAt, usedVariantsData, ...rest }) => ({
      ...rest,
      domainName: domain.name,
      endedAt: endedAt ? new Date(endedAt) : undefined,
      startedAt: startedAt ? new Date(startedAt) : undefined,
      status,
      updatedAt: new Date(updatedAt),
      usedVariantsData: usedVariantsData ?? [],
    }),
  )

export const sortToDTO = (sort: SortInput<AbTestsSortBy>): SortInput<AbTestsSortByDTO> => {
  const { by } = sort

  return { ...sort, by }
}
